import { lazy } from "react";
import { RouteObject } from "react-router-dom";
const AutoAssign = lazy(()=>import("../components/AutoAssign/AutoAssign"));
const ProspectsConfig = lazy(
  () => import("../components/ProspectsConfig/ProspectsConfig")
);
const IntellicloseConfig = lazy(
  () => import("../components/IntellicloseConfig")
);
const LeadCreationConfig = lazy(
  () => import("../components/LeadCreationConfig/LeadCreationConfig")
);
const LeadManageConfig = lazy(
  () => import("../components/LeadManageConfig/LeadManageConfig")
);
const LeadReportConfig = lazy(
  () => import("../components/LeadReportConfig/LeadReportConfig")
);
const LeadTargetConfig = lazy(
  () => import("../components/LeadTargetConfig/LeadTargetConfig")
);
const DigitalLeadConfig = lazy(
  () => import("../components/DigitalLeadConfig/DigitalLeadConfig")
);

const intellicloseConfigRoute: RouteObject = {
  path: "settings/modules/intelliclose",
  element: <IntellicloseConfig />,
  children: [
    {
      index: true,
      element: <LeadCreationConfig />,
    },
    {
      path: "manage-config",
      element: <LeadManageConfig />,
    },
    {
      path: "report-config",
      element: <LeadReportConfig />,
    },
    {
      path: "target-config",
      element: <LeadTargetConfig />,
    },
    {
      path: "digital-lead",
      element: <DigitalLeadConfig />,
    },
    {
      path: "auto-assign",
      element:<AutoAssign />
    },
    {
      path: "prospects-config",
      element: <ProspectsConfig />,
    },
  ],
};

export default intellicloseConfigRoute;
